define('specific/customloader/models/CustomLoaderModel', [

], function() {

    var CustomLoaderModel = Backbone.Model.extend({
        defaults: {
            "percent": 0
        }
    });

    return CustomLoaderModel;
});
